/**
 * Loading skeleton for job cards.
 *
 * @component
 */
const JobSkeleton = () => (
  <div className="bg-background-secondary flex flex-col gap-3 p-4 rounded-xl animate-pulse">
    {/* Header */}
    <div className="flex items-start justify-between gap-2">
      <div className="h-6 w-2/3 bg-text-base/10 rounded"></div>

      <div className="flex items-center gap-3 shrink-0 mt-3">
        <div className="h-4 w-16 bg-text-base/10 rounded"></div>
        <div className="h-4 w-20 bg-text-base/10 rounded"></div>
      </div>
    </div>

    {/* Overview */}
    <div className="space-y-2">
      <div className="h-3 w-full bg-text-base/10 rounded"></div>
      <div className="h-3 w-11/12 bg-text-base/10 rounded"></div>
      <div className="h-3 w-10/12 bg-text-base/10 rounded"></div>
    </div>

    {/* Skills + Button */}
    <div className="flex items-center justify-between gap-2 mt-1">
      {/* Skills */}
      <div className="flex flex-wrap gap-1.5">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-6 w-14 bg-text-base/10 rounded-lg"></div>
        ))}
      </div>

      {/* Button */}
      <div className="h-7 w-16 bg-text-base/10 rounded-lg"></div>
    </div>
  </div>
);

export default JobSkeleton;
